import styled from 'styled-components';
import { Divider } from 'ui/divider';
import { body2, colors, heading5, largeShadow, smallShadow, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const JourneyReviewStateContainer = styled.div`
  display: flex;
  height: ${pxToRem(365)};
  padding: ${spacing.base};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${spacing.base};
  align-self: stretch;

  background: ${colors.backgroundPrimary};
  ${largeShadow};
`;

export const JourneyReviewStateTitle = styled.h5`
  ${heading5};
  color: ${colors.textPrimary};
  text-align: center;
`;

export const JourneyReviewStateDescription = styled.p`
  ${body2};
  color: ${colors.textSecondary};
  text-align: center;
`;

// loader

export const SkeletonContainer = styled.div`
  width: 100%;
  border: ${spacing.single} solid ${colors.borderPrimarySubtle};
  border-radius: 6px;
  background: ${colors.backgroundSecondary};
  ${smallShadow};
`;

export const SkeletonRow = styled.div`
  display: flex;
  width: 352px;
  padding: ${spacing.base};
  align-items: flex-start;
  gap: ${spacing.half};
`;
export const ColumnTextBlock = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${spacing.quarter};
`;

export const ContentDivider = styled(Divider)`
  margin: ${`${spacing.base} 0`};
`;
